import { Component, Input } from '@angular/core';

import { Publication } from 'app/fs/res/publication/model/publication';

@Component( {
    selector: 'res-publication-citation-dialog',
    templateUrl: './publication-citation-dialog.component.html',
    preserveWhitespaces: false
} )
export class PublicationCitationComponent {
    @Input() citations: string[][];
    @Input() publication: Publication = new Publication();

    public display = false; // used in html code

    navigateToBibtexFile( publicationId: number ) {
        let urlProdParameter = this.getExtensionRouterContext( location.pathname );
        window.location.href = location.origin + `/${urlProdParameter}/api/v1/fs/res/publication/${publicationId}/bibtex`;
    }

    private getExtensionRouterContext( url: string ) {
        let firstIndexSlash = url.indexOf( '/' ) + 1;
        let secondIndexSlash = url.indexOf( '/', url.indexOf( '/' ) + 1 );
        return url.substring( firstIndexSlash, secondIndexSlash );
    }
}
